export default "__VITE_ASSET__tMTfgZcGGlZOUyYIXeBUUQ__";